const updates = [
  {
    date: '2026-07-28',
    title: '全新韩漫专区上线',
    desc: '收录超过5000部热门韩漫作品，包含宫廷、恋爱、奇幻等多种题材，下拉式阅读体验全面优化。',
    tag: '新功能',
  },
  {
    date: '2026-07-25',
    title: '日漫经典作品大规模更新',
    desc: '新增300+部日漫经典全本作品，覆盖热血、校园、推理等热门类型，全本完整版免费开放。',
    tag: '内容更新',
  },
  {
    date: '2026-07-20',
    title: '国漫玄幻分类重磅升级',
    desc: '国漫专区新增玄幻修仙、武侠江湖专题，汇集斗破苍穹、完美世界等头部作品全本资源。',
    tag: '内容更新',
  },
  {
    date: '2026-07-15',
    title: '阅读体验全面优化',
    desc: '下拉式阅读流畅度提升40%，图片加载速度优化，夜间模式上线，保护你的视力健康。',
    tag: '优化',
  },
  {
    date: '2026-07-10',
    title: '全本完结区扩展至万部',
    desc: '全本完结漫画专区作品数量突破一万部，涵盖韩漫、日漫、国漫全品类，一口气看到大结局。',
    tag: '里程碑',
  },
  {
    date: '2026-07-05',
    title: '收藏与书签功能上线',
    desc: '支持浏览器本地收藏和阅读进度记录，打开亲亲漫画即可继续上次阅读，追更不迷路。',
    tag: '新功能',
  },
  {
    date: '2026-06-28',
    title: '亲亲漫画月活突破500万',
    desc: '感谢每一位读者的支持与喜爱！我们将继续扩充漫画资源，优化阅读体验，做最好的免费漫画平台。',
    tag: '里程碑',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-timer-line text-sm"></i>
              动态快讯
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              亲亲漫画平台最新更新、功能优化和重要里程碑，与你分享每一步成长
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 md:pl-10 border-l-2 border-background-200/70 space-y-10 md:space-y-12">
              {updates.map((item, i) => (
                <div key={i} className="relative">
                  <div className="absolute -left-[29px] md:-left-[33px] top-1 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100"></div>
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-full ${
                      item.tag === '新功能'
                        ? 'bg-primary-100 text-primary-700'
                        : item.tag === '里程碑'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '优化'
                        ? 'bg-secondary-100 text-secondary-700'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}